module.exports = __webpack_public_path__ + "static/media/Help-Inactive.80ec2dc7.svg";